let language = {
    "BASE_UNHANDLE_ERROR_TITLE": "Unknown error occurred",
    "BASE_UNHANDLE_ERROR_CONTENT": "Oops! An unknown error has occurred, please refresh the page and try again. If the problem still exists, please contact our technical support {{supportmail}}.",

    "SYSTEM_ERROR_TITLE": "Connection Failed",
    "SYSTEM_ERROR_CONTENT": "Oops! Connection failed when you were trying to pass data to the server. Please check your network connection. Alternatively, you can refresh this page and try again. If the problem still exists, please contact our technical support {{supportmail}}",

    "MISSING_AUTHENTICATION_TITLE": "Missing Authentication",
    "MISSING_AUTHENTICATION_CONTENT": "You don't have authentication or it is expired, click [OK] to login again or click [CANCEL] to visit this page as an anonymous user.",
    "MISSING_AUTHORIZED_AUTHENTICATION_CONTENT": "You don't have authentication or it is expired, click [OK] to login again.",
    
    "LACKING_PERMISSION_TITLE": "Lack of permission",
    "LACKING_PERMISSION_CONTENT": "You don't have permission, click [OK] to login again.",

    "NETWORK_CONNECTION_TIMEOUT_TITLE": "Network connection timeout",
    "NETWORK_CONNECTION_TIMEOUT_CONTENT": "There was a network fluctuation, which caused the request to timeout. Please try again later.",

    "NETWORK_UNAVAILABLE_TITLE": "No internet connection",
    "NETWORK_UNAVAILABLE_CONTENT": "Your network is unavailable, Check your data or Wi-Fi connection.",

    "NETWORK_ERROR": "Network Error",

    "UNEXPECTED_ERROR_TITLE": "Something Went Wrong",
    "UNEXPECTED_ERROR_CONTENT": "We encountered an issue. Please refresh the page and try again. If the problem persists, please contact our support team at {{supportmail}}",
}

export { language }